import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

// components
import MenuTitle from "./MenuTitle";
import Link, { AnchorStyled } from "core/SiteHeader/components/Link";

//styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";

const MenuStyled = styled.nav`
    text-align: left;
`;

const LinkStyled = styled(Link)`
    display: block;
    margin: 0rem;

    ${AnchorStyled} {
        display: block;
        text-decoration: none;
        font-size: ${convertPxToRem(15)};
        color: ${colors.secondary.orca};
        line-height: 160%;
        padding: ${convertPxToRem(12)} ${convertPxToRem(16)};
        border-bottom: solid ${convertPxToRem(2)} ${colors.primary.diamond};

        &:hover {
            background-color: ${colors.accent.lightMode.dewdrop};
        }
    }

    &:last-child {
        ${AnchorStyled} {
            ${({ $keepBorder }) =>
                !$keepBorder &&
                css`
                    border: none;
                `}
        }
    }
`;

// component
export const Menu = ({ title, links, keepLastBorder }) => {
    return (
        <MenuStyled>
            {title && <MenuTitle title={title} />}
            <ul>
                {links.map((link, idx) => {
                    return (
                        <LinkStyled
                            key={idx}
                            link={link}
                            onMouseDown={link?.track}
                            $keepBorder={keepLastBorder}
                        />
                    );
                })}
            </ul>
        </MenuStyled>
    );
};

export default Menu;

// prop-types
Menu.propTypes = {
    links: PropTypes.array,
    title: PropTypes.string,
    keepLastBorder: PropTypes.bool,
};
